import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "app/store";

const selectCase = (state: RootState) => state.admin.case;
const selectPatient = (state: RootState) => state.admin.patient;
const selectSpecimens = (state: RootState) => state.admin.specimens;

export const mapAdminCaseToResources = createSelector(
  [selectCase, selectPatient, selectSpecimens],
  (_case, patient, specimens) => {
    return {
      ..._case,
      patient: patient,
      specimens: _case.specimens
        ?.map((specimenId) => specimens[specimenId])
        .filter((v) => v),
    };
  }
);
